<template>
  <div id="chart-table-box">
    <chart-title leftTitle="WMS缺物料预警">
      <el-button type="primary" slot="detail" size="mini" style="margin-right: 20px"
        >详 情</el-button
      ></chart-title
    >
    <div id="chart-table">
      <dv-scroll-board
        :config="config"
        style="width: 100%; height: 100%; margin-top: 10px"
      />
    </div>
  </div>
</template>

<script>
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
export default {
  mixins: [resize],
  name: "left_2",
  components: { ChartTitle },
  data() {
    return {
      config: {
        rowNum: 3,
        headerBGC: "transparent", // 表头背景色
        oddRowBGC: "transparent", // 奇数行背景色
        evenRowBGC: "transparent", // 偶数行背景色
        waitTime: 2000, // 轮播时间间隔(ms)
        align: [
          "center",
          "center",
          "center",
          "center",
          "center",
          "center",
          "center",
        ],
        columnWidth: ["", "", "", "", 70],
        data: [
          [`<span style="color:#409EFF">202212160001</span>`, `<span style="color:#409EFF">XXX商家</span>`, `<span style="color:#409EFF">XXX客户</span>`, `<span style="color:#409EFF">18-亿维雅-IE-1109</span>`, `<span style="color:#409EFF">18张</span>`],
          [`<span style="color:#409EFF">202212160001</span>`, `<span style="color:#409EFF">XXX商家</span>`, `<span style="color:#409EFF">XXX客户</span>`, `<span style="color:#409EFF">18-亿维雅-IE-1109</span>`, `<span style="color:#409EFF">18张</span>`],
          [`<span style="color:#409EFF">202212160001</span>`, `<span style="color:#409EFF">XXX商家</span>`, `<span style="color:#409EFF">XXX客户</span>`, `<span style="color:#409EFF">18-亿维雅-IE-1109</span>`, `<span style="color:#409EFF">18张</span>`],
          [`<span style="color:#409EFF">202212160001</span>`, `<span style="color:#409EFF">XXX商家</span>`, `<span style="color:#409EFF">XXX客户</span>`, `<span style="color:#409EFF">18-亿维雅-IE-1109</span>`, `<span style="color:#409EFF">18张</span>`],
          [`<span style="color:#409EFF">202212160001</span>`, `<span style="color:#409EFF">XXX商家</span>`, `<span style="color:#409EFF">XXX客户</span>`, `<span style="color:#409EFF">18-亿维雅-IE-1109</span>`, `<span style="color:#409EFF">18张</span>`],
        ],
      },
    };
  },
  props: {},
  created() {},
  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
#chart-table-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 18vh;

  #chart-table {
    height: calc(100% - 30px);
    background: transparent;
  }
}
</style>

